import type { FaireProductEntity } from "../../entity_types/product";

export const p_zdszxza3yd: FaireProductEntity = {
  token: "p_zdszxza3yd",
  type: "product",
  name: "Parasite Cleanse",
  brandToken: "b_9cxxv7b6ep",
  brandName: "plant alchemy remedies",
  imageUrl: "https://cdn.faire.com/fastly/6843f48a40411fb3b8c6792d84abfcd883e39b4ed1e415e3f91c7a9b950a3548.webp",
  galleryImageUrls: [],
  priceDollars: 10.5,
  description: "Our Parasite Cleanse is intended for those who may have been diagnosed with a parasite or have been traveling in an environment where the potential for contracting a parasite infection is more prevalent.\n\nThis proprietary herbal cleanse is 100% organic. It is specifically intended to cleanse and strengthen the entire gastrointestinal system. It stimulates your peristaltic action ( the muscular movement of the colon ) and over time strengthens the muscles of the large intestine, halts putrefaction, and disinfects, soothes, and heals the mucous membrane lining of your entire digestive tract. This herbal formula also improves digestion, relieves gas and cramps, and increases the flow of bile which, in turn, cleans the gallbladder, bile ducts, and liver, destroys Candida albicans overgrowth, and promotes healthy intestinal flora, destroys and expels intestinal parasites, increases gastrointestinal circulation and is anti-bacterial, anti-viral and anti-fungal.\n\nSize:   20 capsules",
  tags: [],
  msrpDollars: 21,
  inStock: false,
  meta: {
    source: "api",
    importedAt: "2026-03-25T20:55:35.551Z",
    importedBy: "entity-db-cli"
  },
  categoryTokens: []
};
